import { render, staticRenderFns } from "./DataSearch.vue?vue&type=template&id=90d8e682&scoped=true&"
import script from "./DataSearch.vue?vue&type=script&lang=js&"
export * from "./DataSearch.vue?vue&type=script&lang=js&"
import style0 from "./DataSearch.vue?vue&type=style&index=0&id=90d8e682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d8e682",
  null
  
)

export default component.exports